const getPaginationStats = (paginationMetaData) => {
  return {
    to: paginationMetaData?.to,
    from: paginationMetaData?.from,
    total: paginationMetaData?.total,
  };
};

export default getPaginationStats;
